import { render, staticRenderFns } from "./pkg23.vue?vue&type=template&id=8ddc44e2&"
import script from "./pkg23.vue?vue&type=script&lang=js&"
export * from "./pkg23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports